import {
  createMoneyReport,
  getMoneyReport,
  updateMoneyRepor,
  deleteMoneyRepor,
} from '@/api/reference'

export default {
  CREATE_MONEY_REPORT(_, data) {
    return createMoneyReport(data)
  },
  FETCH_MONEY_REPORT({ commit }, params) {
    return getMoneyReport(params)
      .then(res => {
        commit('SET_MONEY_REPORT', res.data)
      })
  },
  UPDATE_MONEY_REPORT(_, data) {
    return updateMoneyRepor(data)
  },

  DELETE_MONEY_REPORT(_, id) {
    return deleteMoneyRepor(id)
  },
}
